import { renderPage } from "renderPage"
import { UserSecurityRegisterPage } from "./Page"

renderPage({ component: UserSecurityRegisterPage })
